import {
  Grid,
  Paper,
  Typography,
  makeStyles,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import {
  FiArrowLeft
} from "react-icons/fi";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useAuth } from "../../../../context/auth";
import { actionShowSpinner } from "../../../../redux-flow/action/Wrapper/Spinner";
import { getById } from "../../../../services/minutes.service";
import { checkAccess } from "../../utils/index";
import Actions from './Actions';
import FinalDeliberation from './FinalDeliberation';
import GeneralComment from './GeneralComment';
import SlotApproval from './SlotApproval';
import { Tab, Tabs } from './styles';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw"
  },
  subtitle: {
    ...theme.typography.subtitle1
  },
  button: {
    fontSize: "1rem",
    fontWeight: "bold",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50
  },
  buttonOutlined: {
    border: "2px solid",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50
  },
  spacer: {
    marginBottom: 20
  },
  title: {
    fontWeight: "bold",
    fontSize: "1.25rem",
    color: theme.palette.primary.main,
    marginBottom: 20
  }
}));

const EditAction = ({
  t,
  history,
  match,
  actionShowSpinner,
  disabled = false,
  location
}) => {
  const classes = useStyles();
  const { userAccess } = useAuth();

  const [activeTab, setActiveTab] = useState('generalComment');

  const [canApprove, setCanApprove] = useState(false);
  const [canListActions, setCanListActions] = useState(false);
  const [slotTheme, setSlotTheme] = useState('');
  const [generalComment, setGeneralComment] = useState('');
  const [finalDeliberation, setFinalDeliberation] = useState('');
  const [actions, setActions] = useState([]);

  const [minuteId, setMinuteId] = useState('');
  const [slotId, setSlotId] = useState('');
  const [minuteSlotId, setMinuteSlotId] = useState('');
  const [committeeSlotId, setCommitteeSlotId] = useState('');
  const [minuteStatus, setMinuteStatus] = useState('');

  const getData = () => {
    const { minute_slot_id } = location.state;

    getById(minute_slot_id).then(res => {
      setGeneralComment(res.generalComments);

      setFinalDeliberation(res.finalDeliberation);

      const formattedActions = [];

      for (const action of res?.actions) {
        formattedActions.push({
          ...action,
          firstResponsible: action.firstResponsible || '',
          secoundResponsible: action.secondResponsible || '',
        });
      };

      setActions(formattedActions);
    }).finally(() => actionShowSpinner(false));
  }

  useEffect(() => {
    const { slot_id, minute_id, minute_slot_id, comittee_slot_id, slot_type } = location.state;
    
    if(userAccess){
      const hasAccess = checkAccess(userAccess, 'saveApprovers');
      const hasAccessToListActions = checkAccess(userAccess, 'listActionsInMinutes');

      setCanListActions(hasAccessToListActions)

      if(hasAccess && slot_type === 'A'){ 
        setCanApprove(true);
      }

      setMinuteId(minute_id);
      setSlotId(slot_id);
      setMinuteSlotId(minute_slot_id);
      setCommitteeSlotId(comittee_slot_id);

      actionShowSpinner(true);

      getById(minute_slot_id).then(res => {
        setMinuteStatus(res.status);

        setGeneralComment(res.generalComments);

        setFinalDeliberation(res.finalDeliberation);
        
        setSlotTheme(res.slotTheme);

        const formattedActions = [];

        for (const action of res?.actions) {
          formattedActions.push({
            ...action,
            firstResponsible: action.firstResponsible || '',
            secoundResponsible: action.secondResponsible || '',
          });
        };

        setActions(formattedActions);
      }).finally(() => actionShowSpinner(false));
    };
  }, [location, userAccess]);

  return (
    <Grid container className={classes.root} style={{ width: '100%' }}>
      <div style={{width: '100%', alignItems: 'center', display: 'flex'}}>
        <FiArrowLeft color="#465EB6" size={26} style={{marginRight: '12px', cursor: 'pointer'}} onClick={() => history.goBack()}/>
        <Typography variant="h4">
          {`Informações do slot ${slotTheme}`}
        </Typography>
      </div>

      <Paper elevation={1} style={{ padding: 40, marginBottom: 40, width: '100%' }}>
        <Tabs>
          <Tab active={activeTab === 'generalComment'} onClick={() => setActiveTab('generalComment')}>
            <span>{t("forms.minutes.actions.generalComments")}</span>
          </Tab>
          
          <Tab 
            disabled={!canListActions} 
            active={activeTab === 'actions'} 
            onClick={() => {
              if(canListActions){
                setActiveTab('actions')}
              }
            }
          >
            <span>{t("forms.minutes.actions.actions")}</span>
          </Tab>
          
          <Tab 
            disabled={!canApprove}
            active={activeTab === 'finalDeliberation'} 
            onClick={() => {
              if(canApprove){
                setActiveTab('finalDeliberation')
              }
            }}
          >
            <span>{t("forms.minutes.actions.finalDeliberation")}</span>
          </Tab>
          
          <Tab 
            disabled={!canApprove} 
            active={activeTab === 'votes'} 
            onClick={() => {
              if(canApprove){
                setActiveTab('votes');
              }
            }}
          >
            <span>{t("forms.minutes.actions.votes")}</span>
          </Tab>
        </Tabs>

        {activeTab === 'generalComment' && <GeneralComment
          minuteStatus={minuteStatus}
          setGeneralComment={setGeneralComment}
          minuteSlotId={minuteSlotId}
          generalComment={generalComment}
          minuteId={minuteId}
          slotId={slotId}
        />}

        {activeTab === 'actions' && <Actions
          minuteStatus={minuteStatus}
          minuteSlotId={minuteSlotId}
          actions={actions}
          minuteId={minuteId}
          slotId={slotId}
          updateData={getData}
        />}

        {activeTab === 'finalDeliberation' && <FinalDeliberation
          minuteStatus={minuteStatus}
          setFinalDeliberation={setFinalDeliberation}
          minuteSlotId={minuteSlotId}
          comitteeSlotId={committeeSlotId}
          finalDeliberation={finalDeliberation}
          minuteId={minuteId}
          slotId={slotId}
          actionShowSpinner={actionShowSpinner}
        />}

        {activeTab === 'votes' && <SlotApproval
          minuteStatus={minuteStatus}
          slotToApproval={{comitteeSlotId: committeeSlotId}}
          actionShowSpinner={actionShowSpinner}
          t={t}
        />}
      </Paper >
    </Grid >
  );
};

const withRouterActions = withRouter(EditAction);

const mapDispatchToProps = (dispatch) => ({
  actionShowSpinner: (request) => dispatch(actionShowSpinner(request)),
});

const ActionsConnect = connect(
  null,
  mapDispatchToProps
)(withRouterActions);

export default withTranslation()(ActionsConnect);
